import React from 'react';
import PropTypes from 'prop-types';

const Icon = props => {
  const { name, width, height } = props;
  let content = null;

  if (name === 'user') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 21 24"
        width={width}
        height={height}
      >
        <path
          fillRule="evenodd"
          d="M13.565 14.31c2.618-1.172 4.448-3.788 4.448-6.825C18.013 3.357 14.641 0 10.496 0 6.351 0 2.979 3.357 2.979 7.485c0 3.037 1.83 5.653 4.447 6.825C3.128 15.58-.006 19.442-.006 24H1.99c0-4.485 3.815-8.134 8.506-8.134 4.689 0 8.505 3.649 8.505 8.134h1.996c0-4.558-3.134-8.42-7.432-9.69zm-8.59-6.825C4.975 4.461 7.452 2 10.496 2s5.52 2.461 5.52 5.485c0 3.024-2.476 5.484-5.52 5.484-3.044 0-5.521-2.46-5.521-5.484z"
        />
      </svg>
    );
  } else if (name === 'magnifier') {
    content = (
      <svg
        viewBox="0 0 25 24"
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M14.997-.008c-5.352 0-9.706 4.355-9.706 9.707A9.65 9.65 0 0 0 7.459 15.8L.732 22.527l1.436 1.435 6.726-6.726a9.655 9.655 0 0 0 6.103 2.169c5.351 0 9.705-4.355 9.705-9.706 0-5.352-4.354-9.707-9.705-9.707zm0 17.383c-4.233 0-7.676-3.444-7.676-7.676 0-4.233 3.443-7.677 7.676-7.677 4.232 0 7.675 3.444 7.675 7.677 0 4.232-3.443 7.676-7.675 7.676z"
        />
      </svg>
    );
  }

  if (content) {
    return <span className="icon">{content}</span>;
  }
  return null;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Icon.defaultProps = {
  className: null,
  color: null,
  innerRef: undefined,
  width: null,
  height: null,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/app/component/Icon/index.js